var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageHeader',{attrs:{"logo-url":"/img/ForvisMazars.png","app-name":"DataMorph","should-hide-brand-logo":true,"app-iconic-logo":'',"userName":_vm.userName,"handleLogout":_vm.logoutUser}})
}
var staticRenderFns = []

export { render, staticRenderFns }